import React from 'react';
import useFormAPI from '../api';

var FormWatermark = function FormWatermark() {
  var formApi = useFormAPI();
  var state = formApi.state;
  var staticHTML = state.staticHTML;
  return React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: -1
    },
    dangerouslySetInnerHTML: {
      __html: staticHTML
    }
  });
};

export default FormWatermark;